

export class FestivoModel{

constructor(
		public nbloquear:string, 
		public dfechmov:Date,
		) {}

}



// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/RegistrarFestivos/Festivo.model.ts